import React, { useState, useEffect } from "react"
import { useLocation } from "@reach/router"

import { navigate } from "gatsby"
import axios from 'axios';
import queryString from 'query-string'
import PropTypes from "prop-types"
import authClient from "../auth"
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Row from 'react-bootstrap/Row'
import Form from 'react-bootstrap/Form'
import Image from "./image"
import MobileLeftNavigation from './MobileLeftNavigation/mobile-left-navigation'
import Modal from 'react-bootstrap/Modal'
import utcDateTime from '../utcdatetime'

//Import Lazy Loading Component
import Loadable from '@loadable/component'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faAngleLeft, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'

import Styles from './mobile-header.module.scss'

const isBrowser = () => typeof window !== "undefined"
const mobile_exit_popup_seen = isBrowser() ? localStorage.getItem('mobile_exit_popup_seen') ? (localStorage.getItem('mobile_exit_popup_seen') === 'true' ? 'true' : 'false') : 'false' : 'false'
const SignUpPopup = Loadable(() => import("./CallBackModal/SignUpPopup"))
// const Snowfall = Loadable(() => import('react-snowfall'));
var CryptoJS = require("crypto-js")

const MobileHeader = props => {
  const { pathname } = useLocation()
  
  const options = {
    indexStrategy: "Prefix match",
    searchSanitizer: "Lower Case",
    NameIndex: true,
    LongTitleIndex: true,
    TagLineIndex: true,
    SearchByTerm: true,
  }
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [referrar, setReferrar] = useState(false);
  const [lastsection, setLastsection] = useState(false);
  const [courses, setCourses] = useState([]);
  const [cities, setCities] = useState([]);
  const [gift, setGift] = useState(1)
  const [refer, setRefer] = useState({})
  const [msg, setMsg] = useState('')
  const [lastmsg, setLastmsg] = useState('')
  const [detailsuser, setDetailsuser] = useState(true);
  const [change_type, setChangeType] = useState(0)
  const [change_type_value, setChangeTypeValue] = useState('')
  const [ip, setIP] = useState('');

  const getData = async () => {
    const res = await axios.get('https://geolocation-db.com/json/')
    setIP(res.data.IPv4)
  }
  useEffect(()=>{
    getData()
  }, [])
  
  useEffect(() => {
    if (isBrowser()) {
      if (!authClient.isAuthenticated()) {
        localStorage.removeItem('username');localStorage.removeItem('phone')
        if (localStorage.getItem('SignUpPopupDate') == null) {
          localStorage.setItem('SignUpPopupDate', new Date())
        }
      }
      let {clid} = queryString.parse(window.location.search)
      if (clid) {
        localStorage.setItem('student_authenticity_token', atob(atob(atob(atob(atob(clid))))))
        setTimeout(() => {
          authClient.fetchUser(window.location.pathname)
        }, 100);
      }
    }
  }, [isBrowser()])
  useEffect(() => {
    let page_uri = isBrowser() ? '/'+window.location.pathname.substr(1) :  'false', Tawk_API = Tawk_API || {};
    if (Tawk_API) {
      Tawk_API.onLoad = function(){
        if (page_uri.split('/')[1] === 'dashboard' || page_uri.split('/')[1] === 'my-trainings') {
          Tawk_API.hideWidget()
        } else {
          Tawk_API.hideWidget()
        }
      }
    }
  }, [])
  useEffect(() => {
    if (isBrowser()) {
      let mobile_exit_popup_seen_date = localStorage.getItem('mobile_exit_popup_seen_date')
      if (mobile_exit_popup_seen_date) {
        let exit_popup_seen_time = utcDateTime.utcDateTime(mobile_exit_popup_seen_date).getTime()
        let current_time = utcDateTime.utcDateTime('today').getTime()
        let time_difference = current_time - exit_popup_seen_time
        let hour_difference = Math.floor(time_difference / (1000 * 60 * 60))
        if (hour_difference < 8) {
          displayPopUpOrNormalValue(false)
        } else {
          displayPopUpOrNormalValue(true)
        }
      } else {
        displayPopUpOrNormalValue(true)
      }
    }
  }, [change_type])

  async function fetchCourses() {
    fetch(process.env.GATSBY_REACT_APP_COURSES_API+`/certified/all.json`).then(response => response.json()).then(resultData => {
      let data = resultData.reverse()
      setCourses(data)
    })
  }
  async function fetchCities() {
    fetch(process.env.GATSBY_REACT_APP_CITY_API+'/all.json').then(response => response.json()).then(resultData => {
      setCities(resultData)
    })
  }
  function referApi(someProperty){
    let hash_id = ''
    if(ip){
      let password = "lazydog";
      let salt = "salt";
      let iterations = 128;
      let bytes = CryptoJS.PBKDF2(password, salt, { keySize: 48, iterations: iterations });
      let iv = CryptoJS.enc.Hex.parse(bytes.toString().slice(0, 32));
      let key = CryptoJS.enc.Hex.parse(bytes.toString().slice(32, 96));
      hash_id =  CryptoJS.AES.encrypt(ip.toString(), key,{ iv: iv })
    }
    axios.post(process.env.GATSBY_REACT_APP_ENQUIRY , someProperty, {headers: { 'authorization': hash_id.toString()}}).then(res => {}).catch(error => {});
  }

  const handleClose = () => {
    setShow(false);setReferrar(false);setDetailsuser(true)
    setMsg('');setRefer({})
  }
  const handleShow = () => setShow(true);
  const handleShowLastSection = () => setLastsection(true);
  const handleShowLastSectionFalse = () => setLastsection(false);
  const backuserdetails = () => {setReferrar(false);setDetailsuser(true)}
  const displayReferAndEarnModal = () => {
    return (
      <Modal size="lg" show={show} onHide={handleClose} aria-labelledby="refer-and-earn-modal" style={{paddingTop: '100px', zIndex: `9999999999999`}}>
        <Modal.Header style={{ backgroundColor: '#15789f', borderBottom: '1px solid transparent',color: 'white', height: '20vh'}}>
          <Image src={'referandearn.png'} imgStyle={{ objectFit: `contain` }} style={{ width: `100%`, height: `200px`, position: 'relative', top: '-86px', left: 0 }} type={`fluid`} />
          <button type="button" className="close text-white position-absolute" style={{opacity: 1, right: '0.25rem', top: 0}} onClick={handleClose}><span aria-hidden="true">×</span><span className="sr-only">Close</span></button>
        </Modal.Header>
        <Modal.Body style={{backgroundColor: '#15789f'}}>
          <Row className={`text-white mb-4 mx-auto w-100 float-left ${detailsuser === true ? '' : 'd-none'}`}>
            <Form id="form11" className="float-left w-100 mb-0">
              <Form.Label className="col-12 px-0 font-16 mt-2"> We love you ! Please provide your details</Form.Label>
              <Form.Group className="float-left w-100 position-relative mt-3">
                <Form.Control id="name" className={`${Styles.field_wid} ${Styles.form_control}`} name="name" type="text" defaultValue={refer.referred_name} onChange={handleChangeRefer} required /><span className={`${Styles.floating_label11}`}>Enter your name</span>
                <h6 className={`col-12 pr-0 font-14 mb-0 ${msg === 'Please enter your name' ? `d-flex align-items-center` : 'd-none'}`} style={{paddingLeft: '10px'}}><FontAwesomeIcon className="mr-1" icon={faExclamationTriangle} style={{color: 'rgb(255, 202, 46)'}} />{msg}</h6>
              </Form.Group>
              <Form.Group className="float-left w-100 position-relative mt-3">
                <Form.Control id="phone" className={`${Styles.field_wid} ${Styles.form_control}`} name="phone" type="text" defaultValue={refer.referred_phone_number} onChange={handleChangeRefer} required /><span className={`${Styles.floating_label22}`}>Enter your phone number</span>
                <h6 className={`col-12 pr-0 font-14 mb-0 ${(msg === 'Please enter valid phone number' || msg === 'Please enter phone number') ? `d-flex align-items-center` : 'd-none'}`} style={{paddingLeft: '10px'}}><FontAwesomeIcon className="mr-1" icon={faExclamationTriangle} style={{color: 'rgb(255, 202, 46)'}} />{msg}</h6>
              </Form.Group>
              <Form.Group className="float-left w-100 position-relative mt-3">
                <Form.Control id="email" className={`${Styles.field_wid} ${Styles.form_control}`} name="email" type="email" defaultValue={refer.referred_email} onChange={handleChangeRefer} required /><span className={`${Styles.floating_label33}`}>Enter your email Id</span>
                <h6 className={`col-12 pr-0 font-14 mb-0 ${(msg === 'Please enter valid email id' || msg === 'Please enter email id') ? `d-flex align-items-center` : 'd-none'}`} style={{paddingLeft: '10px'}}><FontAwesomeIcon className="mr-1" icon={faExclamationTriangle} style={{color: 'rgb(255, 202, 46)'}} />{msg}</h6>
              </Form.Group>
              <Col xs="12" className="text-center float-left">
                <Button className={`mt-2 ${Styles.refer_next_btn}`} onClick={SubmitReferraldetails} style={{backgroundColor: 'rgb(91, 162, 189)',color: 'white',border: '1px solid transparent',fontSize: '14px'}}>
                  Next <FontAwesomeIcon style={{margin: '0px 0px 0px 0px'}} icon={faAngleRight} size="1x" />
                </Button>
              </Col>
            </Form>
          </Row>
          <Row className={`text-white mb-4 mx-auto w-100 float-left ${referrar === true ? '' : 'd-none'}`}>
            <Form id="form1" className="float-left w-100 mb-0">
              <Form.Label className="col-12 px-0 font-16 mt-2">Please provide the details of your referral</Form.Label>
              <Form.Group className="float-left w-100 position-relative mt-3">
                <Form.Control id="referred_name" className={`${Styles.field_wid} ${Styles.form_control}`} name="referred_name" type="text" defaultValue={refer.referred_name} onChange={handleChangeRefer} required /><span className={`${Styles.floating_label1}`}>Name of Referral</span>
                <h6 className={`col-12 pr-0 font-14 mb-0 ${msg === 'Please enter referral name' ? `d-flex align-items-center` : 'd-none'}`} style={{paddingLeft: '10px'}}><FontAwesomeIcon className="mr-1" icon={faExclamationTriangle} style={{color: 'rgb(255, 202, 46)'}} />{msg}</h6>
              </Form.Group>
              <Form.Group className="float-left w-100 position-relative mt-3">
                <Form.Control id="referred_phone_number" className={`${Styles.field_wid} ${Styles.form_control}`} name="referred_phone_number" type="text" defaultValue={refer.referred_phone_number} onChange={handleChangeRefer} required /><span className={`${Styles.floating_label2}`}>Referral Phone number</span>
                <h6 className={`col-12 pr-0 font-14 mb-0 ${(msg === 'Please enter valid phone number' || msg === 'Please enter phone number' || msg === 'Referrer and referral phone number cannot be same') ? `d-flex align-items-center` : 'd-none'}`} style={{paddingLeft: '10px'}}><FontAwesomeIcon className="mr-1" icon={faExclamationTriangle} style={{color: 'rgb(255, 202, 46)'}} />{msg}</h6>
              </Form.Group>
              <Form.Group className="float-left w-100 position-relative mt-3">
                <Form.Control id="referred_email" className={`${Styles.field_wid} ${Styles.form_control}`} name="referred_email" type="email" defaultValue={refer.referred_email} onChange={handleChangeRefer} required /><span className={`${Styles.floating_label3}`}>Referral Email Id</span>
                <h6 className={`col-12 pr-0 font-14 mb-0 ${(msg === 'Please enter valid email id' || msg === 'Please enter email id' || msg === 'Referrer and referral email cannot be same') ? `d-flex align-items-center` : 'd-none'}`} style={{paddingLeft: '10px'}}><FontAwesomeIcon className="mr-1" icon={faExclamationTriangle} style={{color: 'rgb(255, 202, 46)'}} />{msg}</h6>
              </Form.Group>
              <Form.Group className="float-left w-100 position-relative mt-3">
                <Form.Control id="training_selected" className={`${Styles.field_wid} ${Styles.form_control}`} as="select" name="training_selected" defaultValue={refer.training_selected} onChange={handleChangeRefer} required>
                  <option value="" ></option>
                  {displayCourses(courses)}
                </Form.Control><span className={`${Styles.floating_label4}`}>What course they intend to attend ?</span>
                <h6 className={`col-12 pr-0 font-14 mb-0 ${msg === 'Please select course' ? `d-flex align-items-center` : 'd-none'}`} style={{paddingLeft: '10px'}}><FontAwesomeIcon className="mr-1" icon={faExclamationTriangle} style={{color: 'rgb(255, 202, 46)'}} />{msg}</h6>
              </Form.Group>
              <Form.Group className="float-left w-100 position-relative mt-3">
                <Form.Control id="city_name" className={`${Styles.field_wid} ${Styles.form_control}`} as="select" name="city_name" defaultValue={refer.city_name} onChange={handleChangeRefer} required>
                  <option value="" ></option>
                  {displayCities(cities)}
                </Form.Control><span className={`${Styles.floating_label5}`}>Where they intend to attend the training ?</span>
                <h6 className={`col-12 pr-0 font-14 mb-0 ${msg === 'Please select city' ? `d-flex align-items-center` : 'd-none'}`} style={{paddingLeft: '10px'}}><FontAwesomeIcon className="mr-1" icon={faExclamationTriangle} style={{color: 'rgb(255, 202, 46)'}} />{msg}</h6>
              </Form.Group>
              <Col xs="12" className="text-center float-left">
                <Button className={`${Styles.refer_next_btn} mt-2 mr-4`} onClick={backuserdetails} style={{backgroundColor: 'rgb(91, 162, 189)',color: 'white',border: '1px solid transparent',fontSize: '14px'}}>
                    <FontAwesomeIcon style={{margin: '0px 0px 0px 0px'}} icon={faAngleLeft} size="1x" /> Back
                  </Button>
                <Button className={`mt-2 ${Styles.refer_next_btn}`} onClick={SubmitReferrerdetails} style={{backgroundColor: 'rgb(91, 162, 189)',color: 'white',border: '1px solid transparent',fontSize: '14px'}}>
                  Next <FontAwesomeIcon style={{margin: '0px 0px 0px 0px'}} icon={faAngleRight} size="1x" />
                </Button>
              </Col>
            </Form>
          </Row>
          <Row className={`text-white mb-4 mt-2 mx-auto w-100 float-left justify-center text-center ${referrar === false ? '' : 'd-none'} ${detailsuser === false ? '' : 'd-none'} ${lastsection === true ? 'd-none' : ''}`}>
            <Form className="w-100">
              <Form.Label className="col-12 px-0 float-left" style={{fontSize: '18px',color: 'rgb(91, 162, 189)'}}>Thank you for Referring</Form.Label>
              <Form.Label className="col-12 px-0 float-left" style={{fontSize: '18px'}}>Please select your reward</Form.Label>
              <Col xs="12" className="justify-center float-left">
                <Col xs="12" sm="4" md="4" className={`text-center float-left pointer mt-3`} onClick={()=>selectGift(1)}>
                  <Col md="12" className={`px-0 ${gift === 1 ? `${Styles.giftactive}` : ''}`} id="1-ref" style={{border: '1px solid white', borderRadius: '15px'}}>
                    <Image src={'referamazonvocher.png'} imgStyle={{ objectFit: `contain` }} style={{ width: `100px`, height: `100px` }} type={`fluid`} className="center" />
                    <p style={{fontSize: '12px'}}> Amazon Gift Voucher </p>
                  </Col>
                </Col>
                <Col xs="12" sm="4" md="4" className={`text-center float-left pointer mt-3`}>
                  <Col md="12" className={`px-0 ${gift === 2 ? `${Styles.giftactive}` : ''}`} id="2-ref" style={{border: '1px solid white', borderRadius: '15px', opacity: '.5', pointerEvents: 'none', position:'relative'}}>
                    <Image src={'refershirt.png'} imgStyle={{ objectFit: `contain` }} style={{ width: `100px`, height: `100px` }} type={`fluid`} className="center" />
                    <p style={{color:'red', position:'absolute', top: '35%', fontSize:'24px', left: '25%'}}>Out of Stock</p>
                    <p style={{fontSize: '12px'}}> Playscrum T-shirts </p>
                  </Col>
                </Col>
                <Col xs="12" sm="4" md="4" className={`text-center float-left pointer mt-3`}>
                  <Col md="12" className={`px-0 ${gift === 3 ? `${Styles.giftactive}` : ''}`} id="3-ref"  style={{border: '1px solid white', borderRadius: '15px', opacity: '.5', pointerEvents: 'none', position:'relative'}}>
                    <Image src={'refermugs.png'} imgStyle={{ objectFit: `contain` }} style={{ width: `100px`, height: `100px` }} type={`fluid`} className="center" />
                    <p style={{color:'red', position:'absolute', top: '35%', fontSize:'24px', left: '25%'}}>Out of Stock</p>
                    <p style={{fontSize: '12px'}}> Playscrum Mugs </p>
                  </Col>
                </Col>
                <Col md={{ offset: 2 }} className="text-center float-left"></Col>
              </Col>
              <Col xs="12" className="justify-center float-left mt-4">
                <Button className={`${Styles.refer_next_btn} mt-4 mr-4`} onClick={backdetails} style={{backgroundColor: 'rgb(91, 162, 189)',color: 'white',border: '1px solid transparent',fontSize: '14px'}}>
                  <FontAwesomeIcon style={{margin: '0px 0px 0px 0px'}} icon={faAngleLeft} size="1x" /> Back
                </Button>
                <Button className={`${Styles.refer_next_btn} mt-4`} onClick={Submitdetails} style={{backgroundColor: 'rgb(91, 162, 189)',color: 'white',border: '1px solid transparent',fontSize: '14px'}}>
                  Done
                </Button>
              </Col>
            </Form>
          </Row>
          <Row className={`text-white mb-4 mt-2 mx-auto w-100 float-left justify-center text-center ${lastsection === true ? '' : 'd-none'}`}>
            <Form className="w-100">
              <Form.Label className="col-12 px-0 mb-0 float-left font-weight-bold font-21" style={{color: '#aae8ff'}}>Congratulations</Form.Label>
              <Form.Label className="col-12 px-0 mb-0 float-left" style={{fontSize: '18px',color: '#aae8ff'}}>{lastmsg}</Form.Label>
              <Form.Label className="col-12 px-0 mb-0 float-left font-16" style={{color: '#aae8ff'}}>A confirmation mail has been sent to you</Form.Label>
              <Col xs="12" className="justify-center float-left mt-4">
                <Button className={`${Styles.refer_next_btn} mt-4`} onClick={SubmitdetailsClose} style={{backgroundColor: 'rgb(91, 162, 189)',color: 'white',border: '1px solid transparent',fontSize: '14px'}}>
                  Done
                </Button>
              </Col>
            </Form>
          </Row>
        </Modal.Body>
      </Modal>
    )
  }
  const Submitdetails = () => { handleShowLastSection();submitRefer(); }
  const SubmitdetailsClose = () => {handleClose();handleShowLastSectionFalse();}
  const backdetails = () => {setReferrar(true);}
  const selectGift = gift_value => {
    setGift(gift_value)
    var someProperty = {...refer}
    if (refer) {
      someProperty['gift_selected'] = gift_value;
    }
  }
  const SubmitReferraldetails = event => {
    setMsg('')
    let referral_detail = {...refer}
    if (referral_detail.name) {
      if (referral_detail.phone) {
        let phoneno = /^\d{10}$/;
        if(referral_detail.phone.replace(/\s+/g, '').match(phoneno)){
          if (referral_detail.email) {
            let mailformat = /^\w+([-.]?\w+)*@\w+([-]?\w+)*(\.\w{1,})+$/;
            if(referral_detail.email.match(mailformat)){
              setReferrar(true);setDetailsuser(false)
              fetchCourses();fetchCities()
            }else{
              focusField('email');setMsg('Please enter valid email id')
            }
          }else{
            focusField('email');setMsg('Please enter email id')
          }
        }else{
          focusField('phone');setMsg('Please enter valid phone number')
        }
      }else{
        focusField('phone');setMsg('Please enter phone number')
      }
    }else{
      focusField('name');setMsg('Please enter your name')
    }
  }
  const SubmitReferrerdetails = event => {
    setMsg('')
    let referrer_detail = {...refer}
    if (referrer_detail.referred_name) {
      if (referrer_detail.referred_phone_number) {
        let phoneno = /^\d{10}$/;
        if(referrer_detail.referred_phone_number.replace(/\s+/g, '').match(phoneno)){
          if (referrer_detail.referred_phone_number.replace(/\s+/g, '') !== referrer_detail.phone.replace(/\s+/g, '')) {
            if (referrer_detail.referred_email) {
              let mailformat = /^\w+([-.]?\w+)*@\w+([-]?\w+)*(\.\w{1,})+$/;
              if(referrer_detail.referred_email.match(mailformat)){
                if (referrer_detail.referred_email.toLowerCase() !== referrer_detail.email.toLowerCase()) {
                  if (referrer_detail.training_selected) {
                    if (referrer_detail.city_name) {
                      setMsg('');setReferrar(false)
                    }else{
                      focusField('city_name');setMsg('Please select city')
                    }
                  }else{
                    focusField('training_selected');setMsg('Please select course')
                  }
                } else {
                  focusField('referred_email');setMsg('Referrer and referral email cannot be same')
                }
              }else{
                focusField('referred_email');setMsg('Please enter valid email id')
              }
            }else{
              focusField('referred_email');setMsg('Please enter email id')
            }
          } else {
            focusField('referred_phone_number');setMsg('Referrer and referral phone number cannot be same')
          }
        }else{
          focusField('referred_phone_number');setMsg('Please enter valid phone number')
        }
      }else{
        focusField('referred_phone_number');setMsg('Please enter phone number')
      }
    }else{
      focusField('referred_name');setMsg('Please enter referral name')
    }
  }
  const focusField = id => {
    let focus_field_div = document.getElementById(id);
    if (focus_field_div) {
      focus_field_div.focus()
    }
  }
  const displayCourses = courses => {
    var initial_courses = JSON.parse(JSON.stringify(courses));
    var isLoaded = (initial_courses.length) ? true : false
    if (isLoaded) {
      return (
        initial_courses.map( (course, index) => {
          return (
            <option key={index} value={course.name}> {course.name} </option>
          )
        })
      );
    }
    else {
      return (
        ''
      )
    }
  }
  const displayCities = cities => {
    var initial_cities = JSON.parse(JSON.stringify(cities));
    var isLoaded = (initial_cities.length) ? true : false
    if (isLoaded) {
      return (
        initial_cities.map((city, index) => {
          return (
            <option key={index} value={city.name}>{city.name}</option>
          )
        })
      )
    }
    else {
      return (
        ''
      )
    }
  }
  const handleChangeRefer = event => {
    var someProperty = {...refer}
    if(event.target){
      someProperty[event.target.name] = event.target.value;
    }else{
      someProperty.detail = event;
    }
    setRefer(someProperty)
  }
  const submitRefer = () => {
    let enquiry_email = refer.referred_email;
    let mailformat = /^\w+([-.]?\w+)*@\w+([-]?\w+)*(\.\w{1,})+$/;
    var someProperty = {...refer}
    someProperty['type'] = 'refer';
    if (gift === 0) {
      setLastmsg('You didn’t select a Gift! So we have added the points in your account. You can redeem these points from your dashboard anytime!')
      someProperty['message'] = 'You didn’t select a Gift! So we have added the points in your account. You can redeem these points from your dashboard anytime!';
      referApi(someProperty)
    }else {
      setLastmsg('Your gift is Enroute!')
      someProperty['gift_selected'] = gift;
      if (enquiry_email.match(mailformat)) {
        referApi(someProperty)
      }
    }
  }
  const displayExitPopupModal = () => {
    if (props.course_page) {
      let exit_popup_btn = document.getElementById('exit_popup_request_callback_btn')
      if (exit_popup_btn) {
        exit_popup_btn.click()
      }
    }
  }
  const displayPopUpOrNormalValue = value => {
    if (change_type !== 0 && change_type_value !== '') {
      if (props.course_page) {
        if (localStorage.getItem('mobile_exit_popup_seen') !== 'true' && mobile_exit_popup_seen === 'false') {
          if (value) {
            displayExitPopupModal()
          } else {
            if (change_type_value === 'nav') {
              setOpen(!open)
            } else if (change_type_value === 'home') {
              navigate('/')
            } else if (change_type_value === 'profile') {
              navigate('/update-profile')
            }
          }
        } else {
          if (value) {
            displayExitPopupModal()
          } else {
            if (change_type_value === 'nav') {
              setOpen(!open)
            } else if (change_type_value === 'home') {
              navigate('/')
            } else if (change_type_value === 'profile') {
              navigate('/update-profile')
            }
          }
        }
      } else {
        if (change_type_value === 'nav') {
              setOpen(!open)
            } else if (change_type_value === 'home') {
              navigate('/')
            } else if (change_type_value === 'profile') {
              navigate('/update-profile')
            }
      }
    }
  }
  const openNavigation = () => {
    setChangeType(Math.floor(Math.random(0, 5) * 10))
    setChangeTypeValue('nav')
    // if (props.course_page) {
    //   if (localStorage.getItem('mobile_exit_popup_seen') !== 'true' && mobile_exit_popup_seen === 'false') {
    //     if (exit_popup_seen_time_exceeded) {
    //       displayExitPopupModal()
    //     } else {
    //       setOpen(!open)
    //     }
    //   } else {
    //     if (exit_popup_seen_time_exceeded) {
    //       displayExitPopupModal()
    //     } else {
    //       setOpen(!open)
    //     }
    //   }
    // } else {
    //   setOpen(!open)
    // }
  }
  const goToHomepage = () => {
    setChangeType(Math.floor(Math.random(6, 10) * 10))
    setChangeTypeValue('home')
    // if (props.course_page) {
    //   if (localStorage.getItem('mobile_exit_popup_seen') !== 'true' && mobile_exit_popup_seen === 'false') {
    //     if (exit_popup_seen_time_exceeded) {
    //       displayExitPopupModal()
    //     } else {
    //       navigate('/')
    //     }
    //   } else {
    //     navigate('/')
    //   }
    // } else {
    //   navigate('/')
    // }
  }
  const goToProfilePage = () => {
    setChangeType(Math.floor(Math.random(10, 15) * 10))
    setChangeTypeValue('profile')
    // if (props.course_page) {
    //   if (localStorage.getItem('mobile_exit_popup_seen') !== 'true' && mobile_exit_popup_seen === 'false') {;
    //     if (exit_popup_seen_time_exceeded) {
    //       displayExitPopupModal()
    //     } else {
    //       navigate('/update-profile')
    //     }
    //   } else {
    //     navigate('/update-profile')
    //   }
    // } else {
    //   navigate('/update-profile')
    // }
  }

  return(
    <header style={{ background: `white`, borderBottom: `1px solid darkgrey`, position: `fixed`, top: `0px`, left: `0px`, width: `100vw`, height:`48px`, zIndex:  `9998` }}>
      {/* {pathname === '/dashboard' || pathname === '/dashboard/' ? null : 
        <Snowfall
          // Changes the snowflake color
          color="#dee4fd"
          // Applied to the canvas element
          style={{ zIndex:1, height:'100vh', width:'100vw'}}
          // Controls the number of snowflakes that are created (default 150)
          snowflakeCount={50}
        />
      } */}
      <Col xs="12" sm="12" md="12" lg="12" className='d-flex py-2 px-1' style={{alignItems:'center', height:'48px'}}>
        <div className="fixed-alert-box text-center" id="fixed-error-div"></div>
        <div className="error-modal" id="fixed-error-div"></div>
        <Col xs="4" sm="4" md="4" lg="4" className='px-0 d-flex' style={{alignItems:'center'}} >
          <div onClick={() => openNavigation() }>
            <Image src={'menu_icon.png'} imgStyle={{ objectFit: `cover` }} style={{ width: `32px`, height: `36px`, marginRight:'8px' }} type={`fluid`} className='pointer' />
          </div>
          {/* <Link to="/" style={{ color: `black`, textDecoration: `none` }} > */}
            <div className='mobile-logo' style={{borderRadius:'7px'}} onClick={() => goToHomepage()} />
          {/* </Link> */}
        </Col>
        <Col xs="8" sm="8" md="8" lg="8" className='px-1 d-flex' style={{textAlign:'right', justifyContent:'flex-end',alignItems:'center'}} >
          <Button variant="outline" className={`${Styles.refer_button}`} style={{borderRadius:'8px', padding:'3px 11px 0px 7px',color:'rgb(29, 140, 188)', borderColor: 'rgb(29, 140, 188)',position:'relative'}} onClick={() => handleShow()}>Refer &amp; Earn
            <Image src={'red_star.png'} imgStyle={{ objectFit: `cover` }} style={{ width: `11px`, height: `11px`,position:'absolute',top:'1px',right:'2px' }} type={`fluid`} />
          </Button>
          {/*<Button variant="outline" className={`${Styles.refer_button} p-1`} style={{borderRadius:'8px',color:'rgb(29, 140, 188)', borderColor: 'rgb(29, 140, 188)',position:'relative'}} onClick={() => handleShow()}>
            <Image src={'refer-and-earn.jpeg'} imgStyle={{ objectFit: `contain` }} type={`fluid`} style={{width: '80px', height: '20px'}} />
          </Button>*/}
          {/* <Link to="/update-profile" > */}
            <div className="d-flex font-w500 ml-3 mr-1" style={{justifyContent: 'center'}} onClick={() => goToProfilePage()} >
              <Image src={'profile_active_icon.png'} imgStyle={{ objectFit: `cover` }} style={{ width: `25px`, height: `25px` }} type={`fluid`} />
            </div>
          {/* </Link> */}
        </Col>
      </Col>
      {displayReferAndEarnModal()}
      <MobileLeftNavigation open={open}/>
      {!authClient.isAuthenticated() ? <SignUpPopup /> : null}
    </header>
  )
}

MobileHeader.propTypes = {
  siteTitle: PropTypes.string,
}

MobileHeader.defaultProps = {
  siteTitle: ``,
}

export default MobileHeader
